import { useContext } from "react";

import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Grid,
  Chip,
} from "@material-ui/core";
import { FornecedorContext } from "../contexts/FornecedorContext";
import useFornecedorController from "../controllers/FornecedorController";
import TextFieldErp from "../../../../components/basics/TextFieldErp";
import SelectErp from "../../../../components/basics/SelectErp";
import { HeaderAccordion } from "../styles/Fornecedor";
import { ExpandMore as ExpandMoreIcon } from "@material-ui/icons";
import Filler from "../../../../components/basics/Filler";

export default function AccordionFonecedorAdicionais() {
  const {
    //Contato
    expanded,
    previsao,
    setPrevisao,
    classificacao,
    setClassificacao,
    grupoEconomico,
    setGrupoEconomico,
    observacao,
    setObservacao,
    geralErrors,
    listClassifiction,
  } = useContext(FornecedorContext);
  const { handleChangeOpenAcordion } = useFornecedorController();

  return (
    <Grid item>
      <Accordion
        expanded={expanded.adder || false}
        onChange={() => handleChangeOpenAcordion("adder")}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1bh-content"
          id="panel1bh-header"
        >
          <HeaderAccordion>
            <Grid container spacing={2} alignItems="center">
              <Grid item xs>
                <Chip
                  bgcolor={
                    !expanded.general &&
                    geralErrors.accordions &&
                    geralErrors.accordions.includes("adder")
                      ? "red"
                      : "primary"
                  }
                  textcolor="white"
                  label="OUTRAS INFORMAÇÕES"
                />
              </Grid>
              <Filler />
            </Grid>
          </HeaderAccordion>
        </AccordionSummary>

        <AccordionDetails>
          <Grid container spacing={1} justifyContent="flex-start">
            <Grid item lg={5} md={3} sm={6} xs={12}>
              <TextFieldErp
                id="previsao"
                label="Previsão de Entrega"
                value={previsao}
                setValue={setPrevisao}
              />
            </Grid>
            <Grid item lg={7} md={6} sm={6} xs={12}>
              <SelectErp
                id="classificacao"
                variant="filled"
                label="Classificação"
                optionsList={listClassifiction}
                value={classificacao}
                setValue={setClassificacao}
                descriptionField="descricao"
              />
            </Grid>
            <Grid item lg={5} md={3} sm={6} xs={12}>
              <TextFieldErp
                id="grupoEconomico"
                label="Grupo Econômico"
                value={grupoEconomico}
                setValue={setGrupoEconomico}
                mask="cnpj"
              />
            </Grid>

            <Grid item lg={12} sm={12}>
              <TextFieldErp
                value={observacao}
                setValue={setObservacao}
                label="Observações"
                multiline
                rows={5}
                variant="filled"
              />
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>
    </Grid>
  );
}
